export default {
  methods: {
    fetchCookie() {
      let salesUid = this.$cookies.get("salesUid");
      if (!salesUid) {
        // check for old cookie
        salesUid = this.$cookies.get("nbmuid");
        if (!salesUid) {
          salesUid = this.generateCookie();
        }
        this.addCookie(salesUid);
      }
      // console.log(salesUid);
      if (!salesUid) {
        this.clearCookie();
      }
    },
    generateCookie() {
      let salesUid = [...Array(10)]
        .map(() => (~~(Math.random() * 36)).toString(36))
        .join("");
      return salesUid;
    },
    addCookie(salesUid) {
      const maxAge = 12 * 30 * 24 * 60 * 60;
      this.$cookies.set("salesUid", salesUid, maxAge, "/");
    },
    clearCookie() {
      this.$cookies.remove("salesUid");
    }
  }
};